<template>
  <VDatePicker
    mode="date"
    :locale="$i18n.locale"
    v-model="date"
    borderless
    transparent
    color="movistar-blue"
    :disabled-dates="disabledDates"
    @dayclick="selectDay"
    @update:pages="changePage"
    :min-date="minDate"
    :max-date="maxDate"
    is-required
  />
</template>

<script setup>
  import { ref, watch } from 'vue'

  const props = defineProps({
    disabledDates: Array,
    minDate: Date,
    maxDate: Date,
    selectDay: Function,
    changePage: Function
  })

  const date = ref(new Date())
  const emit = defineEmits(['update:modelValue'])

  watch(date, (newDate) => {
    emit('update:modelValue', newDate)
  })
</script>

<style lang="scss">
  .vc-header .vc-arrow {
    background: #fff;
    color: #066fcb !important;
  }

  button.vc-title {
    background: #fff;
  }
  .vc-header .vc-title {
    font-weight: 700 !important;
    font-size: 14px !important;
  }
  .vc-header .vc-arrow:hover {
    background: #fff !important;
  }
  .vc-focus:focus-within {
    outline: 0;
    box-shadow: none !important;
  }

  .vc-day-content {
    color: var(--primary-10-color) !important;
  }

  .vc-day-content:hover {
    background-color: #e6f5fd !important;
  }

  .vc-day-content.vc-disabled {
    color: var(--vc-gray-300) !important;
  }

  .vc-day-content.vc-disabled:hover {
    background: transparent;
    color: var(--vc-gray-100);
  }

  .vc-weekdays {
    border-bottom: 1px solid #d1d1d1;
    margin-bottom: 5px;
  }

  .vc-container.vc-monthly.vc-movistar-blue.vc-light.vc-transparent {
    width: 100%;
  }

  .vc-highlight.vc-highlight-bg-solid {
    width: 50px;
    height: 28px;
    border-radius: 5px;
  }

  .vc-day-content.vc-focusable.vc-focus.vc-attr.vc-attr.vc-highlight-content-solid.vc-movistar-blue {
    background: transparent;
  }

  .vc-day-content.vc-focusable.vc-focus.vc-attr.vc-disabled {
    border: none;
    background: #fff;
  }
</style>
